export default {
  getListDocumentItem (state) {
    return state.document_items
  },
  getDocummentQueue (state) {
    return state.document_queue
  }
}



// WEBPACK FOOTER //
// ./src/store/module/document-item/getters.js